import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Paper from '@/components/Paper';

import { CODE_BACKGROUND } from './index.constants';
import Element from './Element';

function FutureAlignContent({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        containerWidth: 100,
        containerHeight: 100,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr 1fr' }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="containerWidth"
          id="containerWidth"
          label="Container Width"
          min={25}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoSliderControl
          key="containerHeight"
          id="containerHeight"
          label="Container Height"
          min={30}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ containerWidth, containerHeight }) => {
        const containerHeightPx = normalize(
          containerHeight,
          30,
          100,
          70,
          261
        );
        return (
          <>
            <Row>
              <Column>{codeOutput}</Column>
              <DemoColumn>
                <Container
                  style={{
                    width: containerWidth + '%',
                    height: containerHeightPx / 16 + 'rem',
                  }}
                >
                  <MarginElement>.element</MarginElement>
                </Container>
              </DemoColumn>
            </Row>
          </>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
const Column = styled.div`
  position: relative;
  flex: 1;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  width: 100%;
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
`;

const HighlightedCodeWrapper = styled.div`
  padding: 8px;

  .token-line:nth-child(2) {
    --inset: 18px;
    display: block;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: calc(var(--inset) * -1);
      right: calc(var(--inset) * -1);
      width: calc(100% + var(--inset) * 2);
      height: 100%;
      background: hsl(47deg 83% 56% / 0.08);
      mix-blend-mode: color-dodge;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: calc(var(--inset) * -1);
      bottom: 0;
      width: 4px;
      height: 100%;
      background: hsl(47deg 83% 56% / 0.5);
      border-radius: 0px 2px 2px 0px;
    }
  }
`;

const MarginElement = styled(Element)`
  height: 6rem;
  margin-inline: auto;
  width: 100%;
  max-width: fit-content;
`;

const Container = styled(Paper)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0px;
`;

export default FutureAlignContent;
